import * as React from "react";
export default class NewsItem extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let titleClass = "news-title";
        if (this.props.paidAdvertisement) {
            titleClass = "news-title with-disclaimer";
        }
        return (this.props.active ? React.createElement("a", { className: "news-item", href: this.props.link },
            React.createElement("div", null,
                React.createElement("div", { className: "news-img" },
                    React.createElement("div", { className: "news-img__img", style: { backgroundImage: "url('" + this.props.imgPath + "')" } })),
                React.createElement("div", { className: "news-caption", style: { backgroundColor: this.props.color || "#fff" } },
                    React.createElement("p", { className: "news-header" }, this.props.header),
                    React.createElement("p", { className: titleClass }, this.props.title)))) : null);
    }
}
;
//# sourceMappingURL=news-item.js.map